var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-checkbox',_vm._g({attrs:{"disabled":_vm.disabled},on:{"click":_vm._onClick}},_vm.$listeners),[_c('div',{staticClass:"uni-checkbox-wrapper",style:({
      '--HOVER-BD-COLOR': _vm.activeBorderColor
    })},[_c('div',{staticClass:"uni-checkbox-input",class:{ 'uni-checkbox-input-checked' : _vm.checkboxChecked, 'uni-checkbox-input-disabled' : _vm.disabled },style:(_vm.checkboxStyle)}),_vm._t("default")],2)])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }